import { render, staticRenderFns } from "./EffectChainSelector.vue?vue&type=template&id=96440622&scoped=true&"
import script from "./EffectChainSelector.vue?vue&type=script&lang=js&"
export * from "./EffectChainSelector.vue?vue&type=script&lang=js&"
import style0 from "./EffectChainSelector.vue?vue&type=style&index=0&id=96440622&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96440622",
  null
  
)

export default component.exports